import { render } from "./DisplayLocal.vue?vue&type=template&id=1b32faee&scoped=true"
import script from "./DisplayLocal.vue?vue&type=script&lang=js"
export * from "./DisplayLocal.vue?vue&type=script&lang=js"

import "./DisplayLocal.vue?vue&type=style&index=0&id=1b32faee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b32faee"

export default script